"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var contests_constants_1 = require("@biw/contests-constants");
function getNoGoalSelectedProps(state, program) {
    return {
        tileType: 'no-goal-selected',
        calendarLabel: '',
        lastDayLeftDate: program.goalSelectionToDate,
        /* footer*/
        buttonTextCode: contests_constants_1.KEY_CODES.viewDetails,
        footerMessageCode: '',
        daysLeft: 0
    };
}
exports.default = getNoGoalSelectedProps;
//# sourceMappingURL=no-goal-selected-props.js.map